import DeliveryDetails from './DeliveryDetails'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import {
  changeSelectedDeliveryTime,
  changeTip,
  changeDropoff,
  changeSelectedAddress,
  changeNote
} from '../../../store/actions/order'
import {
  getAddresses,
  createAddress,
  updateAddress
} from '../../../store/effects/user'
import * as publicSelectors from '../../../selectors/public'
import * as userSelectors from '../../../selectors/user'
import * as orderSelectors from '../../../selectors/order'

const mapStateToProps = state => ({
  deliveryTimes: publicSelectors.getDeliveryTimes(state),
  selectedDeliveryTime: orderSelectors.getSelectedDeliveryTime(state),
  addresses: userSelectors.getAddresses(state),
  addressesLoading: userSelectors.addressesLoading(state),
  addressesCached: userSelectors.addressesCached(state),
  selectedTip: orderSelectors.getTip(state),
  selectedDropoff: orderSelectors.getSelectedDropoff(state),
  selectedAddress: orderSelectors.getSelectedAddress(state),
  initialNote: orderSelectors.getNote(state)
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      changeSelectedDeliveryTime,
      getAddresses,
      createAddress,
      updateAddress,
      changeTip,
      changeDropoff,
      changeSelectedAddress,
      changeNote
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(DeliveryDetails)



// WEBPACK FOOTER //
// ./src/modules/Checkout/DeliveryDetails/index.js